import {IProjectInfo} from '../models/project/project-info';

const hasValue = (value: unknown): boolean => value !== null && value !== undefined && `${value}`.trim() !== '';

const INTAKE_REQUIRED_FIELDS: readonly {label: string; isFilledIn: (info: IProjectInfo) => boolean}[] = [
    {label: 'PAGE_PROJECT_DETAILS.form.bvo', isFilledIn: (info) => hasValue(info.bvo)},
    {label: 'PAGE_PROJECT_DETAILS.form.constructionCostsEstimate', isFilledIn: (info) => hasValue(info.constructionCosts)},
    {label: 'PAGE_PROJECT_DETAILS.form.tenderCosts', isFilledIn: (info) => hasValue(info.tenderCosts)},
    {label: 'PAGE_PROJECT_DETAILS.form.tenderDate', isFilledIn: (info) => hasValue(info.tenderDate)},
    {label: 'PAGE_PROJECT_DETAILS.form.client', isFilledIn: (info) => hasValue(info.client)}
];

/** Translation keys of the Projectgegevens fields that must be filled in before the projectintake is submitted. */
export function getMissingIntakeFields(info: IProjectInfo | null | undefined): string[] {
    return INTAKE_REQUIRED_FIELDS
        .filter((field) => !info || !field.isFilledIn(info))
        .map((field) => field.label);
}
